import { EnvironmentProviders } from '@angular/core';
import { provideHighcharts } from 'highcharts-angular';

export function provideXmlReport() : EnvironmentProviders {
    const providers = [
        provideHighcharts({
            modules: () => {
                return [
                    import('highcharts/esm/modules/accessibility'),
                    import('highcharts/esm/modules/exporting'),
                    import('highcharts/esm/highcharts-more'),
                    import('highcharts/esm/themes/sunset')
                ];
            }
        })
    ];

    return providers as unknown as EnvironmentProviders;
}
